import { Component, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild, inject } from '@angular/core'
import { InputDialogComponent, StepState } from '../input-dialog/input-dialog.component'
import { Observable, take } from 'rxjs'
import { Article, ListingState, downloadArticlesRemote, downloadFinished, selectAllArticles, selectListingState, selectStatusState } from 'src/app/state'
import { Store } from '@ngrx/store'
import { ExportColumnGroup } from '../filtering-search-component-base/filtering-search-types'
import { PaginatedTableCommon } from '../paginated-table-common/paginated-table-common'
import { ToastService } from 'src/app/services/toast.service'
import { BackEndService } from 'src/app/services/backend.service'
import { selectUser } from 'src/app/state/user.reducer'
import { Dictionary } from '@ngrx/entity'

@Component({
    template: '',
    standalone: true
})
export class DownloadComponentBase<TTItem extends Article> implements OnChanges, OnDestroy {

    @ViewChild('exportExcelDialog') excelExportDialogComponent: InputDialogComponent = {} as InputDialogComponent

    @Input() contentSet = ''
    @Input() exportColumnsToChoose: ExportColumnGroup[] = []
    @Input() selectedArticleIDs: string[] = []

    public downloadsNotAllowed: boolean = false
    public internalUser: boolean = false
    public exportChosenSomeColumns: boolean = true

    public listing$: Observable<ListingState>
    public exportProgress: number = 0
    public exportProgressMessage: string = ''
    public exportDownloadURL: string = ''
    public exportPerDownloadLimit = 1000000
    public exportPerDownloadLimitByRow = false
    public downloadStartedHere = true
    private downloadIntervalTimer: any

    public exportButton: string = PaginatedTableCommon.DefaultExportButton

    public exportHelpFormState = 'waiting'

    public loading$

    public store = inject(Store<TTItem>)
    private toastService = inject(ToastService)
    private backendService = inject(BackEndService)


    public downloadParts: Dictionary<boolean | string | Dictionary<boolean | string> > = {

    }

    constructor(
    ) {

        this.listing$ = this.store.select(selectListingState)

        this.loading$ = this.store.select(selectStatusState).subscribe(state => {
            if (state.loading && state.downloadID !== '' && this.downloadStartedHere) {
                let exportProgressRequest: any = null
                let exportCheckCountDown = 180 * 4
                this.downloadIntervalTimer = setInterval(
                    () => {
                        if (exportProgressRequest === null) {
                            exportProgressRequest = this.backendService.downloadprogress(state.downloadID).subscribe(
                                (res: any) => {
                                    exportProgressRequest = null
                                    this.exportProgressMessage = `${res?.response?.status} ${res.response.message}`
                                    this.exportProgress = res.response.progress
                                    if (this.exportProgress == 100) {
                                        this.exportDownloadURL = res.response.message.split(' ')[3]
                                        this.store.dispatch(downloadFinished())
                                        clearInterval(this.downloadIntervalTimer)
                                        this.downloadStartedHere = false
                                        this.excelExportDialogComponent?.advanceToNextStep()
                                        this.toastService.show(`Click <a href="${this.exportDownloadURL}">here</a> if the file was not downloaded automatically.`, {
                                            header: 'Download complete',
                                            classname: 'bg-success',
                                            autohide: false,
                                            delay: 5000,
                                        })

                                    } else {
                                        exportCheckCountDown--
                                        if (exportCheckCountDown === 0) {
                                            this.store.dispatch(downloadFinished())
                                            clearInterval(this.downloadIntervalTimer)
                                            this.downloadStartedHere = false
                                            this.excelExportDialogComponent?.advanceToNextStep()
                                            this.toastService.show(`Download failed`, {
                                                classname: 'bg-danger',
                                                autohide: false,
                                                delay: 5000,
                                            })
                                        }
                                    }
                                }
                            )
                        }
                    },
                    500)
            }
        })

        this.store.select(selectUser).pipe(take(1)).subscribe(
            user => {
                if (user?.downloads) {
                    this.downloadsNotAllowed = false
                } else {
                    this.downloadsNotAllowed = true
                }
                this.internalUser = user?.internal || false
            }
        )

    }
    ngOnChanges(changes: SimpleChanges): void {
        if (this.exportColumnsToChoose.length > 0) {
            setTimeout(() => {
                this.excelExportDialogComponent.showModal()
            }, 100)
        }
    }

    ngOnDestroy(): void {
        clearInterval(this.downloadIntervalTimer)
        this.loading$.unsubscribe()
    }

    exportStepChanged(exportStep: StepState) {
        if (exportStep.step === 2) {
            let total = 0
            this.listing$.pipe(take(1)).subscribe(
                listing => {
                    total = listing.total
                }
            )

            if (total < 20000) {
                this.store.dispatch(downloadArticlesRemote({
                    action: {
                        export: 'xls',
                        title: '',
                        area: this.contentSet + '/download',
                        rows: -1,
                        parts: this.downloadParts,
                        selected: this.selectedArticleIDs,
                        columns: [],
                        state: this.excelExportDialogComponent.state
                    }
                }))
                this.downloadStartedHere = true
                this.exportProgress = 20
                this.exportProgressMessage = 'Starting download'
            } else {
                this.excelExportDialogComponent.activeModal?.close()
            }
        }
    }


    exportCancelled() {
        clearInterval(this.downloadIntervalTimer)
    }
}
